import { render, staticRenderFns } from "./HomePointsEcomotive.vue?vue&type=template&id=0f202518&scoped=true"
import script from "./HomePointsEcomotive.vue?vue&type=script&lang=ts"
export * from "./HomePointsEcomotive.vue?vue&type=script&lang=ts"
import style0 from "./HomePointsEcomotive.vue?vue&type=style&index=0&id=0f202518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f202518",
  null
  
)

export default component.exports